// Site-styled chat button for Shopify Inbox (<shopify-chat>): opens/closes the chat through the element's own
// show()/close() and hides Inbox's launcher (exposed as ::part(activator)) only once this button is working.
(() => {
  const btn = document.querySelector('[data-xo-chat]');
  const html = document.documentElement;
  const host = () => document.querySelector('shopify-chat');

  const toggle = () => {
    window.xoChatStartClosed = false; // the visitor opened it on purpose
    const chat = host();
    if (!chat) return;
    if (typeof chat.show === 'function') {
      if (chat.open) chat.close(); else chat.show();
      return;
    }
    chat.shadowRoot?.querySelector('[part="activator"]')?.click(); // fallback: press Inbox's own launcher
  };

  const ready = () => {
    if (!host()) return;
    if (btn) {
      btn.hidden = false;
      html.classList.add('xo-chat-ready'); // CSS hides Inbox's own launcher from here on
      btn.addEventListener('click', toggle);
    }
    // Refresh: if the chat still reopened itself, close it once.
    if (window.xoChatStartClosed) {
      let tries = 0;
      const shut = setInterval(() => { if (!window.xoChatStartClosed) { clearInterval(shut); return; } const c = host(); if (c && c.open && typeof c.close === 'function') { c.close(); clearInterval(shut); } if (++tries > 20) clearInterval(shut); }, 250);
    }
    // While the chat window is open, the site's custom cursor hides and the normal pointer returns.
    let last = null;
    setInterval(() => {
      const chat = host();
      const open = !!(chat && (chat.open || chat.shadowRoot?.querySelector('[part="dialog"][aria-hidden="false"]')));
      if (open !== last) {
        last = open;
        html.classList.toggle('xo-chat-open', open);
        btn?.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }, 250);
  };

  if (!btn) html.classList.add('xo-chat-fallback'); // no site button on this page: keep Inbox's own launcher
  if (!window.customElements) return;
  customElements.whenDefined('shopify-chat').then(ready);
})();
